const pdfWorkerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export default pdfWorkerSrc;
